export default __webpack_public_path__ + "static/media/sun.aa1e7e27.svg";